import request from '@/utils/request'
import { tokenName } from '@/config'

export function login(data) {
  return request({
    url: '/mg/sso-api/SsoAdminAcc/doLogin',
    method: 'post',
    data,
  })
}

export function getUserInfo(accessToken) {
  return request({
    url: '/mg/sso-api/SsoAdminAcc/getLoginInfo',
    method: 'get',
    data: {
      [tokenName]: accessToken,
    },
  })
}

export function logout() {
  return request({
    url: '/mg/sso-api/SsoAdminAcc/doExit',
    method: 'get',
  })
}
export function getAdminUserPage(data) {
  return request({
    url: '/mg/sso-api/ssoAdmin/page',
    method: 'post',
    data: data,
  })
}

// 修改密码
export function putChangePassWord(data) {
  return request({
    url: '/mg/sso-api/userAccount/changePassWord',
    method: 'put',
    data: data,
  })
}

//校验图形验证码
export function reqCheck(data) {
  return request({
    url: '/mg/sso-api/captcha/check',
    method: 'post',
    data: data,
  })
}
//获取图形验证码
export function reqGet(data) {
  return request({
    url: '/mg/sso-api/captcha/get',
    method: 'post',
    data: data,
  })
}
